const Grill = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-grill"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-grill"
      viewBox="0 0 24 24"
      width={_width}
      {...props}
    >
      <path d="m11.04,3V1c0-.552.447-1,1-1s1,.448,1,1v2c0,.552-.447,1-1,1s-1-.448-1-1Zm5,1c.553,0,1-.448,1-1V1c0-.552-.447-1-1-1s-1,.448-1,1v2c0,.552.447,1,1,1Zm-8,0c.553,0,1-.448,1-1V1c0-.552-.447-1-1-1s-1,.448-1,1v2c0,.552.447,1,1,1Zm15.922,5.691c-.73,3.186-2.844,5.97-5.755,7.649l1.781,5.343c.175.524-.108,1.09-.632,1.265-.105.035-.212.052-.316.052-.419,0-.809-.265-.948-.684l-.439-1.316h-6.653c-.553,0-1-.448-1-1s.447-1,1-1h5.986l-.667-2H7.76l-.557,1.671c.49.456.797,1.107.797,1.829,0,1.381-1.119,2.5-2.5,2.5s-2.5-1.119-2.5-2.5c0-1.319,1.022-2.399,2.317-2.493l.555-1.666C2.96,15.663.845,12.878.115,9.691c-.207-.904.004-1.837.581-2.561.572-.718,1.426-1.13,2.344-1.13h17.997c.918,0,1.771.412,2.344,1.13.577.724.788,1.657.581,2.562Z" />
    </svg>
  );
};

export default Grill;
